
export const GET_TOTALCOMMENTS=`GET_TOTALCOMMENTS`;
export const SET_TOTALCOMMENTS=`SET_TOTALCOMMENTS`;
export const SET_CASEID=`SET_CASEID`
export const SET_FOLLOWUPSTATUS=`SET_FOLLOWUPSTATUS`
export const getTotalComments =(data) =>({
    type: GET_TOTALCOMMENTS,
    value:data
})

export const setTotalComments =(data) =>({
    type: SET_TOTALCOMMENTS, 
    value: data
});

export const setCaseID =(data) =>({
    type: SET_CASEID, 
    value: data
});
export const setFollowupStatus =(data) =>({
    type: SET_FOLLOWUPSTATUS, 
    value: data
});